module.exports = __webpack_public_path__ + "static/media/sup.af23c809.webp";